import React, { useState } from 'react';
import { useSelector } from 'react-redux';
import 'bootstrap/dist/css/bootstrap.min.css';
import './About.css';

const faqData = [
  {
    question: 'What services does Etihad Gharbia Contracting Company offer?',
    answer: 'Etihad Gharbia specializes in Contracting, Manpower Supply, Equipment Rental, Transportation, IT & GPS solutions, and Construction.',
  },
  {
    question: 'Which industries or clients does Etihad Gharbia serve?',
    answer: 'We serve prestigious clients such as Saudi Technic, Saudi Arabia Railways, Ministry of Health, Ministry of Interior, and others within the KSA market.',
  },
  {
    question: 'How can I contact Etihad Gharbia Contracting Company?',
    answer: 'You can reach us by phone at +966502114467 or visit our website at www.egccsaudi.com.',
  },
  {
    question: 'When was Etihad Gharbia Contracting Company founded?',
    answer: 'The company was founded in 2010 and has since grown to 501-1,000 employees.',
  },
  {
    question: 'What is Etihad Gharbia’s commitment to its clients?',
    answer: 'We are dedicated to integrity, professionalism, and exceeding client expectations through high-quality services and innovative solutions.',
  },
  {
    question: 'What makes Etihad Gharbia a trusted contracting company in KSA?',
    answer: 'Our combination of skilled professionals, industry expertise, and customer-centric approach ensures unmatched value and quality on every project.',
  },
];

const FaqSection = ({ heading = 'Frequently Asked Questions' }) => {
  const { language } = useSelector((state) => state.language);
  const [openIndex, setOpenIndex] = useState(null);

  const translations = {
    gb: {
      heading: 'Frequently Asked Questions',
      faqs: faqData,
    },
    sa: {
      heading: 'الأسئلة الشائعة',
      faqs: [
        {
          question: 'ما هي الخدمات التي تقدمها شركة الاتحاد الغربية للمقاولات؟',
          answer: 'تتخصص شركة الاتحاد الغربية في المقاولات، توريد القوى العاملة، تأجير المعدات، النقل، حلول تكنولوجيا المعلومات ونظام تحديد المواقع، والبناء.',
        },
        {
          question: 'ما هي الصناعات أو العملاء الذين تخدمهم شركة الاتحاد الغربية؟',
          answer: 'نخدم عملاء مرموقين مثل التقنية السعودية، سكك الحديد السعودية، وزارة الصحة، وزارة الداخلية، وغيرهم ضمن سوق المملكة العربية السعودية.',
        },
        {
          question: 'كيف يمكنني التواصل مع شركة الاتحاد الغربية للمقاولات؟',
          answer: 'يمكنك التواصل معنا عبر الهاتف على الرقم +966502114467 أو زيارة موقعنا الإلكتروني على www.egccsaudi.com.',
        },
        {
          question: 'متى تأسست شركة الاتحاد الغربية للمقاولات؟',
          answer: 'تأسست الشركة في عام 2010 ونمت منذ ذلك الحين لتشمل ما بين 501 إلى 1000 موظف.',
        },
        {
          question: 'ما هو التزام شركة الاتحاد الغربية تجاه عملائها؟',
          answer: 'نحن ملتزمون بالنزاهة، الاحترافية، وتجاوز توقعات العملاء من خلال تقديم خدمات عالية الجودة وحلول مبتكرة.',
        },
        {
          question: 'ما الذي يجعل شركة الاتحاد الغربية موثوقة في المملكة العربية السعودية؟',
          answer: 'مزيجنا من المحترفين المهرة، الخبرة الصناعية، والنهج المتمحور حول العميل يضمن قيمة وجودة لا مثيل لهما في كل مشروع.',
        },
      ],
    },
    fr: {
      heading: 'Questions Fréquemment Posées',
      faqs: [
        {
          question: 'Quels services propose Etihad Gharbia Contracting Company ?',
          answer: 'Etihad Gharbia se spécialise dans les contrats, la fourniture de main-d’œuvre, la location d’équipements, le transport, les solutions informatiques et GPS, et la construction.',
        },
        {
          question: 'Quels secteurs ou clients Etihad Gharbia dessert-elle ?',
          answer: 'Nous servons des clients prestigieux tels que Saudi Technic, Saudi Arabia Railways, le ministère de la Santé, le ministère de l’Intérieur, et d’autres sur le marché saoudien.',
        },
        {
          question: 'Comment puis-je contacter Etihad Gharbia Contracting Company ?',
          answer: 'Vous pouvez nous contacter par téléphone au +966502114467 ou visiter notre site web à www.egccsaudi.com.',
        },
        {
          question: 'Quand Etihad Gharbia Contracting Company a-t-elle été fondée ?',
          answer: 'L’entreprise a été fondée en 2010 et compte aujourd’hui entre 501 et 1 000 employés.',
        },
        {
          question: 'Quel est l’engagement d’Etihad Gharbia envers ses clients ?',
          answer: 'Nous nous engageons à faire preuve d’intégrité, de professionnalisme et à dépasser les attentes des clients grâce à des services de haute qualité et des solutions innovantes.',
        },
        {
          question: 'Qu’est-ce qui fait d’Etihad Gharbia une entreprise de confiance en Arabie Saoudite ?',
          answer: 'Notre combinaison de professionnels qualifiés, d’expertise industrielle et d’approche centrée sur le client garantit une valeur et une qualité inégalées sur chaque projet.',
        },
      ],
    },
    de: {
      heading: 'Häufig gestellte Fragen',
      faqs: [
        {
          question: 'Welche Dienstleistungen bietet die Etihad Gharbia Contracting Company an?',
          answer: 'Etihad Gharbia ist spezialisiert auf Bauverträge, Arbeitskräftevermittlung, Gerätevermietung, Transport, IT- und GPS-Lösungen sowie Bauarbeiten.',
        },
        {
          question: 'Welche Branchen oder Kunden bedient Etihad Gharbia?',
          answer: 'Wir bedienen renommierte Kunden wie Saudi Technic, Saudi Arabia Railways, das Gesundheitsministerium, das Innenministerium und andere auf dem saudi-arabischen Markt.',
        },
        {
          question: 'Wie kann ich die Etihad Gharbia Contracting Company kontaktieren?',
          answer: 'Sie können uns telefonisch unter +966502114467 erreichen oder unsere Website unter www.egccsaudi.com besuchen.',
        },
        {
          question: 'Wann wurde die Etihad Gharbia Contracting Company gegründet?',
          answer: 'Das Unternehmen wurde 2010 gegründet und ist seitdem auf 501–1.000 Mitarbeiter gewachsen.',
        },
        {
          question: 'Was ist das Engagement von Etihad Gharbia gegenüber seinen Kunden?',
          answer: 'Wir sind der Integrität, Professionalität und dem Übertreffen der Kundenerwartungen durch hochwertige Dienstleistungen und innovative Lösungen verpflichtet.',
        },
        {
          question: 'Was macht Etihad Gharbia zu einem vertrauenswürdigen Unternehmen in Saudi-Arabien?',
          answer: 'Unsere Kombination aus qualifizierten Fachkräften, Branchenexpertise und kundenorientiertem Ansatz garantiert unvergleichlichen Wert und Qualität bei jedem Projekt.',
        },
      ],
    },
  };

  const t = translations[language] || translations.gb;

  const toggleFAQ = (index) => {
    setOpenIndex((prevIndex) => (prevIndex === index ? null : index));
  };

  return (
    <section
      className="faq-section" >
      <div className="container px-3">
        <h1 className="faq-title fw-bold display-4 display-md-3 display-lg-2 mb-4">
          {t.heading || heading}
          <div className="faq-underline d-flex justify-content-center mt-2">
            <span
              className="line"
              style={{
                width: '40px',
                height: '3px',
                backgroundColor: '#c8102e',
              }}
            />
            <span
              className="dot"
              style={{
                width: '5px',
                height: '3px',
                backgroundColor: '#c8102e',
                margin: '0 4px',
              }}
            />
            <span
              className="line"
              style={{
                width: '40px',
                height: '3px',
                backgroundColor: '#c8102e',
              }}
            />
          </div>
        </h1>

        <div className="faq-grid">
          {t.faqs.map(({ question, answer }, index) => (
            <div key={`faq-${index}`} className="faq-item">
              <div
                className="faq-box faq-box-hover"
                onClick={() => toggleFAQ(index)}
                role="button"
                tabIndex={0}
              >
                <span className="faq-number">
                  {index + 1}. {question}
                </span>
                <span className="faq-icon">
                  {openIndex === index ? '−' : '+'}
                </span>
              </div>
              {openIndex === index && (
                <div className="faq-answer">
                  <p>{answer}</p>
                </div>
              )}
            </div>
          ))}
        </div>

        {/* Add hover styles */}
        <style>{`
          .faq-box-hover:hover {
            transform: translateY(-2px);
            box-shadow: 0 4px 8px rgba(0, 0, 0, 0.1);
            transition: all 0.3s ease;
          }
        `}</style>
      </div>
    </section>
  );
};

export default FaqSection;







